<!--<masonry [masonryItems]="masonryItems" [masonryColumnCount]="1"></masonry>-->
<!--<div class="module-wrapper">
    <div class="module drop-shadow bottom">
        <h3 *ngIf="isSearching">Searching...</h3>
        <p *ngIf="!isSearching && results.length == 0" class="text-center">No matching results</p>
        <table *ngIf="!isSearching && results.length > 0" class="std-table stacked-sm">
            <thead>
            <th>Date Sent</th>
            <th>Consumer Name</th>
            <th>Message</th>
            </thead>
            <tbody>
                <tr *ngFor="let result of results">
                    <td data-label="Date Sent">{{result.messageDate | date:'dd/MM/yyyy' }}</td>
                    <td data-label="Consumer Name">{{result.consumerName}}</td>
                    <td data-label="Message">{{result.message}}</td>
                </tr>
            </tbody>
        </table>
        <app-pagination *ngIf="!isSearching" [page]="results.page" [pages]="results.totalPages" (pageChange)="pageSelected($event)"></app-pagination>
    </div>
</div>-->



<masonry [masonryItems]="masonryItems" [masonryColumnCount]="1"></masonry>
